import 'moment/locale/id';
import * as ExcelJS from 'exceljs';
import moment from 'moment';

const styleColumns = (
    worksheet: ExcelJS.Worksheet,
    indexRow: number,
) => {
    worksheet.getRow(indexRow).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
    };
    worksheet.getRow(indexRow).eachCell(function (cell) {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {
                argb: 'F6991D',
            },
        };
    });
    worksheet.getRow(indexRow).font = {
        name: 'Arial Black',
        size: 10,
        bold: true,
    };
};

const exportWorkbook = async (workbook: ExcelJS.Workbook, fileName: string) => {
    workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
    });
};

const createWorkbook = () => {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Looyal';
    workbook.lastModifiedBy = 'Looyal';
    workbook.created = new Date();
    workbook.modified = new Date();
    return workbook;
};

const createWorksheet = (workbook: ExcelJS.Workbook, sheetName: string = 'Sheet1') => {
    let worksheet;
    worksheet = workbook.addWorksheet(sheetName);
    return worksheet;
};

const addDataRows = (
    worksheet: ExcelJS.Worksheet,
    data: any[],
) => {
    data.forEach((rowData, index) => {
        worksheet.addRow(rowData);
    });
};

const setColumnWidths = (worksheet: ExcelJS.Worksheet) => {
    const colWidths = [25, 30, 35, 35, 25];
    worksheet.columns = colWidths.map((width) => ({ width }));
};

const getSourceDescription = (source: string, merchantTitle: string): string => {
    switch (source) {
        case 'ROUND ROBIN':
            return `${merchantTitle} dialihkan pada penanggung jawab baru secara otomatis.`;
        case 'MAIN UPDATE':
            return `Pengguna mengubah penanggung jawab pada ${merchantTitle} secara manual.`;
        case 'MAIN CREATE':
            return `Pengguna membuat ${merchantTitle} secara manual.`;
        case 'AUTO CREATE':
            return `Sistem membuat ${merchantTitle} secara otomatis dari chat yang masuk.`;
        case 'IMPORT EXCEL':
            return `${merchantTitle} diimpor melalui berkas Excel.`;
        default:
            return 'Sumber perubahan tidak diketahui.';
    }
};

export const exportExcelPICMerchant = async (
    nameFile: string,
    source: string,
    data?: any[],
    merchantTitle?: string
) => {
    let exportData: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook);

    var header = ['Waktu', 'Nama ' + merchantTitle, 'Penanggung Jawab Sebelumnya', 'Penanggung Jawab Saat Ini', 'Sumber Perubahan'];
    worksheet.getRow(1).values = header;

    if (!data) return console.error(`Data ${source} - Export is empty`);

    Array.from(data!).map((row, index) => {
        var temp_excel = [];
        temp_excel.push(
            moment(row.dateCreated).format('DD MMMM YYYY HH:mm'),
            row.merchantName,
            row.userNameBefore || '-',
            row.userNameAfter,
            row.source
        );
        exportData.push(temp_excel);
    });

    addDataRows(worksheet, exportData);
    setColumnWidths(worksheet);
    styleColumns(worksheet, 1);

    const uniqueSources = Array.from(new Set(data!.map(item => item.source)));
    const legendData = uniqueSources.map(src => [
        src,
        getSourceDescription(src, merchantTitle!)
    ]);

    worksheet.mergeCells('G2:H2');
    worksheet.getCell('G2').value = 'Keterangan Sumber Perubahan';
    worksheet.getCell('G2').font = { bold: true };

    worksheet.getCell('G3').value = 'Sumber';
    worksheet.getCell('H3').value = 'Keterangan';
    worksheet.getCell('G3').font = { bold: true };
    worksheet.getCell('H3').font = { bold: true };

    legendData.forEach((row, index) => {
        worksheet.getCell(`G${4 + index}`).value = row[0];
        worksheet.getCell(`H${4 + index}`).value = row[1];
    });

    worksheet.getColumn('G').width = 25;
    worksheet.getColumn('H').width = 60;
    
    exportWorkbook(workbook, `${nameFile}.xlsx`);
};